import React from 'react';
import Navbar from '../components/Navbar';
import { Card, CardContent } from '../components/ui/card';

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="terms-conditions">
      <Navbar />

      <div className="pt-24 pb-12">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="font-heading text-4xl font-bold text-slate-900 mb-2">Terms and Conditions</h1>
          <p className="text-slate-500 mb-8">Last updated: January 2026</p>

          <Card className="border-slate-200">
            <CardContent className="p-8 prose prose-slate max-w-none">
              <h2>1. Acceptance of Terms</h2>
              <p>By accessing and using AISkillFlow ("the Platform"), you agree to be bound by these Terms and Conditions. If you do not agree, please do not use the Platform.</p>

              <h2>2. Account Registration</h2>
              <ul>
                <li>You must provide accurate and complete information when creating an account</li>
                <li>You are responsible for maintaining the security of your account credentials</li>
                <li>You must be at least 18 years old to create an account</li>
                <li>One person may not maintain multiple accounts</li>
              </ul>

              <h2>3. User Roles</h2>
              <h3>Students</h3>
              <ul>
                <li>May purchase and access courses</li>
                <li>Receive lifetime access to purchased courses</li>
                <li>May participate in the referral program</li>
              </ul>
              <h3>Instructors</h3>
              <ul>
                <li>Must subscribe to an instructor plan to list courses</li>
                <li>Are responsible for the content they publish</li>
                <li>Receive 80% of course sales revenue</li>
                <li>Must comply with content guidelines</li>
              </ul>

              <h2>4. Course Purchases</h2>
              <ul>
                <li>All prices are in USD unless otherwise stated</li>
                <li>Purchases grant lifetime access to the course content</li>
                <li>Courses may be updated by instructors at any time</li>
                <li>Access may be revoked for violations of these terms</li>
              </ul>

              <h2>5. Instructor Subscriptions</h2>
              <ul>
                <li>Instructor plans are billed monthly</li>
                <li>Course limits apply based on subscription tier</li>
                <li>Cancellation does not affect existing student access to courses</li>
              </ul>

              <h2>6. Content Guidelines</h2>
              <p>All content must:</p>
              <ul>
                <li>Be original or properly licensed</li>
                <li>Not infringe on intellectual property rights</li>
                <li>Not contain illegal, harmful, or offensive material</li>
                <li>Be accurate and not misleading</li>
              </ul>

              <h2>7. Intellectual Property</h2>
              <ul>
                <li>Instructors retain ownership of their course content</li>
                <li>Students may not redistribute or resell course content</li>
                <li>The AISkillFlow platform and branding are our intellectual property</li>
              </ul>

              <h2>8. Payment Terms</h2>
              <ul>
                <li>Payments are processed securely through Stripe</li>
                <li>Instructor payouts are processed within 7-14 business days</li>
                <li>Minimum payout amount is $10</li>
              </ul>

              <h2>9. Limitation of Liability</h2>
              <p>AISkillFlow is provided "as is" without warranties. We are not liable for any indirect, incidental, or consequential damages arising from your use of the platform.</p>

              <h2>10. Termination</h2>
              <p>We reserve the right to suspend or terminate accounts that violate these terms. You may close your account at any time by contacting support.</p>

              <h2>11. Changes to Terms</h2>
              <p>We may update these terms at any time. Continued use of the platform constitutes acceptance of updated terms.</p>

              <h2>12. Contact</h2>
              <p>For questions about these Terms, contact us at: <strong>info@aiskillflowpro.com</strong></p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
